module.exports = __webpack_public_path__ + "static/img/自信的.041f1ada.png";